import { twClassMerge } from '@healthhub/react-ui';
import type { ReactNode } from 'react';


interface Props {
  children?: ReactNode;
  className?: string;
  extra?: ReactNode;
  title?: ReactNode;
}

const StyledCard = ({ children, className, extra, title }: Props) => (
  <div className={twClassMerge('border border-solid border-primary-grey bg-white tabular-nums', className)}>
    {!!title && (
      <div className="flex items-center justify-between px-4">
        <div className="py-4">{title}</div>
        {!!extra && <div className="ml-auto py-4">{extra}</div>}
      </div>
    )}
    <div className="card-body p-4">{children}</div>
  </div>
);

export default StyledCard;
